var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SdkApi } from '@or-sdk/sdk-api';
export class Password {
    constructor(params) {
        const { token, discoveryUrl, sdkApiUrl } = params;
        this.sdkApi = new SdkApi({
            token,
            discoveryUrl,
            sdkUrl: sdkApiUrl,
        });
    }
    startResetPassword(email, redirectPath) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.sdkApi.makeRequest({
                route: '/password/forgot-start',
                method: 'POST',
                data: {
                    email,
                    redirectPath,
                },
            });
        });
    }
    endResetPassword(_a) {
        return __awaiter(this, arguments, void 0, function* ({ email, key, password, type }) {
            return yield this.sdkApi.makeRequest({
                route: '/password/forgot-end',
                method: 'POST',
                data: {
                    email,
                    key,
                    password,
                    type,
                },
            });
        });
    }
    createMultiUser(_a) {
        return __awaiter(this, arguments, void 0, function* ({ token, type, password }) {
            return yield this.sdkApi.makeRequest({
                route: '/multi-user/create-finish',
                method: 'POST',
                data: {
                    token,
                    password,
                    type,
                },
            });
        });
    }
}
//# sourceMappingURL=Password.js.map